/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox model module.
 * @module model/AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox
 * @version 1.0
 */
class AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox {
    /**
     * Constructs a new <code>AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox</code>.
     * @alias module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox
     */
    constructor() { 
        
        AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox} The populated <code>AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox();

            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('vehicleGrade')) {
                obj['vehicleGrade'] = ApiClient.convertToType(data['vehicleGrade'], 'Number');
            }
            if (data.hasOwnProperty('boxBlessedFlag')) {
                obj['boxBlessedFlag'] = ApiClient.convertToType(data['boxBlessedFlag'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} nftUid
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox.prototype['nftUid'] = undefined;

/**
 * @member {Date} createdAt
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox.prototype['createdAt'] = undefined;

/**
 * @member {Number} vehicleGrade
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox.prototype['vehicleGrade'] = undefined;

/**
 * @member {Boolean} boxBlessedFlag
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox.prototype['boxBlessedFlag'] = undefined;






export default AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox;

